import { render, staticRenderFns } from "./VAfreecaIcon.vue?vue&type=template&id=7f789fd7&scoped=true"
import script from "./VAfreecaIcon.vue?vue&type=script&lang=js"
export * from "./VAfreecaIcon.vue?vue&type=script&lang=js"
import style0 from "./VAfreecaIcon.vue?vue&type=style&index=0&id=7f789fd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f789fd7",
  null
  
)

export default component.exports